var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',[_vm._t("default",[_vm._v("Jokes:")])],2),_vm._l((_vm.jokes),function(joke,index){return _c('single-joke',_vm._b({key:index},'single-joke',joke,false))})],2)}
var staticRenderFns = []

export { render, staticRenderFns }